"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TeamLogo } from "@/components/ui/TeamLogo";
import { MatchStats } from "../partials/stats/MatchStats";
interface StatsTabProps {
  homeTeamName: string;
  awayTeamName: string;
  homeTeamLogo?: string;
  awayTeamLogo?: string;
  homeTeamColor?: string;
  awayTeamColor?: string;
  homeTeamCountryCode?: string;
  homeTeamCountryFlag?: string;
  homeTeamPrimaryColor?: string;
  homeTeamSecondaryColor?: string;
  awayTeamCountryCode?: string;
  awayTeamCountryFlag?: string;
  awayTeamPrimaryColor?: string;
  awayTeamSecondaryColor?: string;
}

/**
 * StatsTab - Displays match statistics for finished matches
 * Uses team colors for bar charts, falling back to tenant brand colors
 */
export const StatsTab: React.FC<StatsTabProps> = t0 => {
  const $ = _c(21);
  const {
    homeTeamName,
    awayTeamName,
    homeTeamLogo,
    awayTeamLogo,
    homeTeamColor,
    awayTeamColor,
    homeTeamCountryCode,
    homeTeamCountryFlag,
    homeTeamPrimaryColor,
    homeTeamSecondaryColor,
    awayTeamCountryCode,
    awayTeamCountryFlag,
    awayTeamPrimaryColor,
    awayTeamSecondaryColor
  } = t0;
  let t1;
  if ($[0] !== homeTeamCountryCode || $[1] !== homeTeamCountryFlag || $[2] !== homeTeamLogo || $[3] !== homeTeamPrimaryColor || $[4] !== homeTeamSecondaryColor) {
    t1 = <TeamLogo src={homeTeamLogo} size="md" countryCode={homeTeamCountryCode} countryFlag={homeTeamCountryFlag} primaryColor={homeTeamPrimaryColor} secondaryColor={homeTeamSecondaryColor} />;
    $[0] = homeTeamCountryCode;
    $[1] = homeTeamCountryFlag;
    $[2] = homeTeamLogo;
    $[3] = homeTeamPrimaryColor;
    $[4] = homeTeamSecondaryColor;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const homeTeamImage = t1;
  let t2;
  if ($[6] !== awayTeamCountryCode || $[7] !== awayTeamCountryFlag || $[8] !== awayTeamLogo || $[9] !== awayTeamPrimaryColor || $[10] !== awayTeamSecondaryColor) {
    t2 = <TeamLogo src={awayTeamLogo} size="md" countryCode={awayTeamCountryCode} countryFlag={awayTeamCountryFlag} primaryColor={awayTeamPrimaryColor} secondaryColor={awayTeamSecondaryColor} />;
    $[6] = awayTeamCountryCode;
    $[7] = awayTeamCountryFlag;
    $[8] = awayTeamLogo;
    $[9] = awayTeamPrimaryColor;
    $[10] = awayTeamSecondaryColor;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const awayTeamImage = t2;
  let t3;
  if ($[12] !== awayTeamColor || $[13] !== awayTeamImage || $[14] !== awayTeamLogo || $[15] !== awayTeamName || $[16] !== homeTeamColor || $[17] !== homeTeamImage || $[18] !== homeTeamLogo || $[19] !== homeTeamName) {
    t3 = <div className="space-y-6"><MatchStats homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamImage={homeTeamImage} awayTeamImage={awayTeamImage} homeTeamColor={homeTeamColor} awayTeamColor={awayTeamColor} /></div>;
    $[12] = awayTeamColor;
    $[13] = awayTeamImage;
    $[14] = awayTeamLogo;
    $[15] = awayTeamName;
    $[16] = homeTeamColor;
    $[17] = homeTeamImage;
    $[18] = homeTeamLogo;
    $[19] = homeTeamName;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
};